<template>
  <div class="component-card">
    <div class="d-flex">
      <i
        class="fa fa-arrow-left fa-lg font-weight-bold cursor-pointer m__r--10 m__t--2"
        @click="$router.replace('/admin-pembelajaran/requester')"/>
      <h3>CREATE DOKUMEN {{ categoryName }}</h3>
    </div>

    <b-row>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
          <label> Titile </label>
          <j-input
            v-model="$v.data_master.title.$model"
            :max-length="255"
            placeholder="Insert Title"/>
        </b-form-group>

        <!-- <b-form-group :class="{'error-input' : $v.data_master.category.$error}">
          <label> Category </label>
          <j-single-select
            v-model="$v.data_master.category.$model"
            :options="list_category"
            :placeholder="'Select Category'"
            value-format="object"
            label="label"/>
        </b-form-group> -->

        <j-form-base
          v-if="showAdditionalInfo"
          ref="jFormCreate"
          :data-fields="dataFields"/>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label> Attachment </label>
          <j-upload-file
            v-model="$v.data_master.file.$model"
            :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
            :api-token="token"
            :img-default="$v.data_master.file.$model"
            :url-upload="url_upload"
            @url="getUrl"/>
        </b-form-group>
        <!-- <b-form-group :class="{'error-input' : $v.data_master.file.$error}">
          <label> File </label><br>
          <j-singleupload
            v-model="$v.data_master.file.$model"
            :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
            :api-token="token"
            :img-default="$v.data_master.file.$model"
            :url-upload="url_upload"
            @url="getUrl"/>
          <label>
            Please choose file with supported format file
            xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
          </label>
        </b-form-group> -->
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="m__t--20">
          <b-button
            class="btn blue m__r--5"
            @click="saveData">
            Save
          </b-button>
          <!-- <b-button
            class="btn gray"
            @click="$router.replace('/admin-pembelajaran/requester')">
            Cancel
          </b-button> -->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  components: {
    jFormBase,
    jUploadFile,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Create Data',
      },

      data_master: {
        title: '',
        category: null,
        file: null,
      },
      list_category: [],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      showAdditionalInfo: false,
      dataFields: [],
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },

    categoryName() {
      let name = '';
      switch (this.$route.params.category_id) {
        case '1':
          name = 'RPP';
          break;
        case '2':
          name = 'SILABUS';
          break;
        case '3':
          name = 'JADWAL PELAJARAN';
          break;
        case '15':
          name = 'KTSP';
          break;
        default :
          name = '';
      }
      return name;
    },
  },
  watch: {
  },
  created() {
    // this.getListCategory(1).then((res) => {
    //   this.list_category = res.data.data.data.map(e => ({
    //     id: e.id,
    //     label: e.title,
    //   }));
    // });

    this.getAdditionalInfo(this.$route.params.category_id).then((res) => {
      this.dataFields = res.data.data.map(el => ({
        id: el.id,
        name: el.field_name,
        type: el.type,
        placeholder: el.placeholder,
        field_key: el.field_key,
        options: el.options ? el.options.map(val => ({
          id: val,
          name: val,
        })) : [],
        is_delete: false,
        is_editable: false,
        is_mandatory: false,
      }));
      this.showAdditionalInfo = true;
    });
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['getListCategory', 'createAdminPembelajaran', 'getAdditionalInfo']),

    getUrl(data) {
      this.data_master.file = data;
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.$refs.jFormCreate.getData().then((params) => {
          const dataAdditional = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          const param = {
            title: this.data_master.title,
            category_id: this.$route.params.category_id,
            attachment: this.data_master.file,
            additional_info: dataAdditional,
          };
          this.createAdminPembelajaran(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/admin-pembelajaran/requester');
              }, 1500);
            }
          });
        });
      }
    },
  },
  validations() {
    return {
      data_master: {
        title: { required },
        category: { },
        file: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-pembelajaran/jAdminPembelajaranCreate.vue